import { Fragment, h } from 'preact';
import './article.scss';



export function ArticleSuggestion(props: any) {
    const rootServiceInstance = props?.msgData?.hostInstance?.rootService;
    const languageData = props?.hostInstance?.languagedata;
    return (
        <div>
            {
                (props?.msgData?.articles || [])?.map((article: any, inx: any) => (
                    <div className={"suggestion-item-card aa-each-suggestion " + (inx < props?.msgData?.viewCount ? '' : 'aa-hidden')}>
                        <div className="suggestion-header-faq aa-suggestion-header">
                            <div className="titles-info-sec aa-suggestion-title">

                                {!article.link && article.title && (
                                    <h2 className="aa-text-xs">{article.title}</h2>
                                )}
                                {article.link && article.title && (
                                    <h2 className="aa-text-xs">
                                        <a className="moreText aa-article-link" role="link">
                                            {article.title}
                                        </a>
                                    </h2>
                                )}
                            </div>
                        </div>
                        <div className="suggestion-body-faq">
                            <p className="aa-desc-xs suggestion-paragraph" dangerouslySetInnerHTML={{ __html: rootServiceInstance.sanitizeHTML(article?.content) }} />

                            <div className="more-links-buttons aa-seemore-buttons aa-hidden">
                                <button className="more-link-text aa-text-xs aa-more-button"  role="link">{languageData?.MORE_TEXT}</button>
                            </div>


                            {article.link && !article.title && (
                                <div className="more-links-buttons">
                                    <button className="more-link-text aa-text-xs aa-article-link" role="link">{languageData?.VIEW_FULL_ARTICLE_2}</button>
                                </div>
                            )}
                        </div>

                    </div>
                ))

            }
           
        </div>
    )
}

